// extracted by mini-css-extract-plugin
export default {"map":"FindShopLocation_map__GUfZu"};